module.exports = __webpack_public_path__ + "img/gaikan01.cd5d67a6.jpg";